import { Modal, ModalSize } from '@economic/gaudi';
import { useCurrentAgreement } from '@economic/react-app';
import React, { useState } from 'react';

import PlanUpgradeDialog from '../../../../pages/home/PlanUpgradeDialog';

/**
 * Ensure that if the trial expires we greet customer with forced upgrade.
 */
export default function UpgradeExpiredTrialDialog() {
    const [size, setSize] = useState<ModalSize>('lg');
    const agreement = useCurrentAgreement();

    const isTrialExpired = agreement.subscription.trial?.expiryDate
        ? new Date(agreement.subscription.trial.expiryDate).getTime() < Date.now()
        : false;

    if (!isTrialExpired) {
        return null;
    }

    return (
        <Modal visible size={size} showCloseButton={false} hideOnEsc={false}>
            {({ hide }) => <PlanUpgradeDialog hide={hide} setSize={setSize} />}
        </Modal>
    );
}
